/**
 * @generated SignedSource<<6d68469a69fdd4fb79cc0c0e3feb9116>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DismissGuidanceInput = {
  clientMutationId?: string | null;
  notestreamId: string;
  topicId: string;
};
export type NoteCardDismissGuidanceMutation$variables = {
  input: DismissGuidanceInput;
};
export type NoteCardDismissGuidanceMutation$data = {
  readonly noteStreamDismissGuidance: {
    readonly ok: boolean | null;
  } | null;
};
export type NoteCardDismissGuidanceMutation = {
  response: NoteCardDismissGuidanceMutation$data;
  variables: NoteCardDismissGuidanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DismissGuidancePayload",
    "kind": "LinkedField",
    "name": "noteStreamDismissGuidance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteCardDismissGuidanceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteCardDismissGuidanceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a94cde27bc48786c217f7ea033ca889b",
    "id": null,
    "metadata": {},
    "name": "NoteCardDismissGuidanceMutation",
    "operationKind": "mutation",
    "text": "mutation NoteCardDismissGuidanceMutation(\n  $input: DismissGuidanceInput!\n) {\n  noteStreamDismissGuidance(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e3c306b2c0bca1242b2754248659de3";

export default node;
